const usePageHeaderStyles = () => {
    return {
        pageHeaderStyles: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 2,
            px: 0
        },
        filterSectionStyles: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        titleContainerStyles: {
            display: 'flex',
            alignItems: 'center',
            gap: 2
        },
        iconContainerStyles: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        }
    };
};
export default usePageHeaderStyles;
